import type { SVGProps } from 'react'

const RealTimeTrendIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
    {...props}
  >
    <path
      d="M2.9998 21.5L6.20695 18.2927C6.64194 17.8577 7.34722 17.8577 7.78223 18.2927L8.68558 19.1961C9.12058 19.631 9.82585 19.631 10.2608 19.1961L13.4569 16M13.4569 16H10.4912M13.4569 16V19.1428"
      stroke="#112A55"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1.46753 15L7.52025 8.94665C8.26902 8.1978 9.48309 8.19777 10.2319 8.94658L11.7869 10.5015C12.5356 11.2503 13.7497 11.2503 14.4984 10.5015L20 5M20 5H14.8949M20 5V10.4098"
      stroke="#2563EB"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M26.1111 2.77832V2.77832C27.6452 2.77832 28.8889 4.02197 28.8889 5.5561V18.3339C28.8889 21.0953 26.6503 23.3339 23.8889 23.3339H6.11109C3.34966 23.3339 1.11108 21.0953 1.11108 18.3339V5.5561C1.11108 4.02198 2.35474 2.77832 3.88886 2.77832V2.77832"
      stroke="#112A55"
      strokeLinecap="round"
    />
    <path
      d="M20.5554 23.334H9.44434V27.2229H20.5554V23.334Z"
      stroke="#112A55"
      strokeLinejoin="round"
    />
    <path
      d="M5.25684 27.3398H24.744"
      stroke="#112A55"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default RealTimeTrendIcon
